import { render, staticRenderFns } from "./ListaDeFacturas.vue?vue&type=template&id=a90ef9c0&scoped=true"
import script from "./ListaDeFacturas.vue?vue&type=script&lang=js"
export * from "./ListaDeFacturas.vue?vue&type=script&lang=js"
import style0 from "./ListaDeFacturas.vue?vue&type=style&index=0&id=a90ef9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90ef9c0",
  null
  
)

export default component.exports